import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';

import { ImageSizeDirectiveEvent } from './image-size.directive.types';

@Directive({
  selector: '[dotImageSize]',
})
export class ImageSizeDirective implements AfterViewInit {
  @Output() dotOnImageLoad: EventEmitter<ImageSizeDirectiveEvent> =
    new EventEmitter();

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const img: HTMLImageElement | null =
      this.el.nativeElement.querySelector('img');

    if (img) {
      img.onload = () => {
        // Use naturalWidth and naturalHeight for intrinsic dimensions
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        const aspectRatio = 100 * (height / width);
        this.dotOnImageLoad.emit({ width, height, aspectRatio });
      };
    }
  }
}
